export default __webpack_public_path__ + "static/media/FSKoopman-BoldItalic.6c9331e6.woff2";